import { ClientLabel } from 'src/pages/Clients/ClientView/client-tab-label';
import { ConversationLabel } from 'src/pages/Conversations/conversation-tab-label';
import { SiteLabel } from 'src/pages/Sites/site-tab-label';
import { GlobalTab, TabType } from 'src/utils/hooks';

export const TabLabel = ({ entity, type }: GlobalTab) => {
  if (!entity) return;

  switch (type) {
    case TabType.Conversation:
      return <ConversationLabel {...entity} />;
    case TabType.Site:
      return <SiteLabel {...entity} />;
    case TabType.Client:
      return <ClientLabel {...entity} />;
    default:
      return null;
  }
};
